import {checkFEVersionSaga} from './check-fe-version-saga';

/** System sagas responsible for FE version polling and refresh prompts. */
export const systemSagas = [checkFEVersionSaga];
